import { useEffect } from 'react';
import * as Sentry from "@sentry/react";
import { createSentryAnonymousUser } from '../../errors/errors';
import { useAuthenticatedUser } from '@ngt/opms';

const useSentryUser = () => {
    const authenticatedUser = useAuthenticatedUser();
    useEffect(() => {
        // no user, clear sentry user.
        if (!authenticatedUser.data) {
            // set Sentry User back to anonymous.

            Sentry.setUser(createSentryAnonymousUser());
            return;
        }

        // user, set sentry user.
        Sentry.setUser({
            id: authenticatedUser.data.userName,
            username: authenticatedUser.data.userName,
            fullName: authenticatedUser.data.displayName,
            authenticated: true
        })

        return () => {
            // set Sentry User back to anonymous.

            Sentry.setUser(createSentryAnonymousUser());
        }
    }, [authenticatedUser.data]);
}

export default useSentryUser;